// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"flight-landing"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M10.2802 2.5L12.212 3.01764L14.7779 11.9874L20.2837 13.4626C21.0839 13.6771 21.5587 14.4996 21.3443 15.2998C21.1299 16.1 20.3074 16.5748 19.5072 16.3604L2.60352 11.8311L2.93169 6.74264L4.38057 7.13087L5.02205 9.3733L10.1415 10.745L10.2802 2.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.2802 2.5L12.212 3.01764L14.7779 11.9874L20.2837 13.4626C21.0839 13.6771 21.5587 14.4996 21.3443 15.2998C21.1299 16.1 20.3074 16.5748 19.5072 16.3604L2.60352 11.8311L2.93169 6.74264L4.38057 7.13087L5.02205 9.3733L10.1415 10.745L10.2802 2.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 20H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FlightLandingIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flight-landing',
    ref,
    icon: element,
  },
));

FlightLandingIcon.displayName = 'FlightLandingIcon';

export default FlightLandingIcon;
